var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[_vm.isMobile ? 'mobile' : 'pc'],attrs:{"id":"app"}},[_c('div',{staticClass:"theme-f",class:{ 'has-bar': _vm.hasBuyBar }},[_c('headerVue',{key:'hd' + _vm.componentKey}),_c('main',{staticClass:"f-main"},[_c('router-view',{on:{"refresh":_vm.handleRefresh}})],1),_c('footerVue',{key:'ft' + _vm.componentKey})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }